export const SectConstant = {
    data() {
        return {
            sectConstant: {
                lxg: {
                    code: "lxg",
                    name: "凌雪阁",
                    agilityToPhysicsAttackPowerCof:1772,
                    agilityToPhysicsOvercomeCof:553,
                },
                lxgW: {
                    code: "lxgW",
                    name: "凌雪阁-悟"
                },
            }

        }
    }
}